import { Component } from '@angular/core';
import { MedalliaService } from 'src/app/services/medallia/medallia.service';
import { StoreService } from 'src/app/services/store/store.service';

@Component({
	selector: 'app-survey',
	templateUrl: './survey.component.html',
	styleUrls: ['./survey.component.scss'],
})
export class SurveyComponent {
	parameters$ = this.storeService.initialParameters$;

	constructor(
		private readonly medalliaService: MedalliaService,
		private readonly storeService: StoreService
	) {}

	onShowSurvey(surveyCode: string) {
		this.medalliaService.showFeedBackSurvey(surveyCode);
	}
}
